import React from "react";

function Community() {
  return (
    <div className="community">
      <div className="tag_btn wow fadeInUp">Community</div>
      <div className="t f_24 wow fadeInUp">What Our Users Say</div>
      <div className="box">
        <div className="matter">
          <a href="">
            <div className="pic">
              <img
                src="https://ik.imagekit.io/kruyy0oih/7.jpg?updatedAt=1743523907553"
                alt=""
              />
            </div>
            <div className="info">
              <p className="name f_24">Lily</p>
              <div className="stars">
                <img src="./images/star.svg" alt="" />
                <img src="./images/star.svg" alt="" />
                <img src="./images/star.svg" alt="" />
                <img src="./images/star.svg" alt="" />
                <img src="./images/star.svg" alt="" />
              </div>
              <div className="des">
                "The interview felt just like the real interview — same pacing,
                same pressure. I was ready."
              </div>
            </div>
          </a>
          <a href="">
            <div className="pic">
              <img
                src="https://ik.imagekit.io/kruyy0oih/3.jpg?updatedAt=1743523900649"
                alt=""
              />
            </div>
            <div className="info">
              <p className="name f_24">Alex</p>
              <div className="stars">
                <img src="./images/star.svg" alt="" />
                <img src="./images/star.svg" alt="" />
                <img src="./images/star.svg" alt="" />
                <img src="./images/star.svg" alt="" />
                <img src="./images/star.svg" alt="" />
              </div>
              <div className="des">
                "It’s the only tool that actually teaches you how to get better,
                not just practice."
              </div>
            </div>
          </a>
          <a href="">
            <div className="pic">
              <img
                src="https://ik.imagekit.io/kruyy0oih/9.jpeg?updatedAt=1743523906675"
                alt=""
              />
            </div>
            <div className="info">
              <p className="name f_24">Brandon</p>
              <div className="stars">
                <img src="./images/star.svg" alt="" />
                <img src="./images/star.svg" alt="" />
                <img src="./images/star.svg" alt="" />
                <img src="./images/star.svg" alt="" />
                <img src="./images/star2.svg" alt="" />
              </div>
              <div className="des">
                "I went from confused to case-ready in 2 weeks. The report
                feedback was scarily accurate. "
              </div>
            </div>
          </a>
        </div>

        <div className="matter">
          <a href="">
            <div className="pic">
              <img
                src="https://ik.imagekit.io/kruyy0oih/6.jpg?updatedAt=1743523904024"
                alt=""
              />
            </div>
            <div className="info">
              <p className="name f_24">Sophia</p>
              <div className="stars">
                <img src="./images/star.svg" alt="" />
                <img src="./images/star.svg" alt="" />
                <img src="./images/star.svg" alt="" />
                <img src="./images/star.svg" alt="" />
                <img src="./images/star.svg" alt="" />
              </div>
              <div className="des">
                "WeKruit was recommended by our career office. I use it to
                structure my prep, manage referrals, and connect with students
                prepping for the same firms. "
              </div>
            </div>
          </a>
          <a href="">
            <div className="pic">
              <img
                src="https://ik.imagekit.io/kruyy0oih/12.jpg?updatedAt=1743523903983"
                alt=""
              />
            </div>
            <div className="info">
              <p className="name f_24">Ray</p>
              <div className="stars">
                <img src="./images/star.svg" alt="" />
                <img src="./images/star.svg" alt="" />
                <img src="./images/star.svg" alt="" />
                <img src="./images/star.svg" alt="" />
                <img src="./images/star.svg" alt="" />
              </div>
              <div className="des">
                "My friend referred WeKruit to me after her Bain offer — I saw
                why. The reports were clearer than anything I’d used before. "
              </div>
            </div>
          </a>
          <a href="">
            <div className="pic">
              <img
                src="https://ik.imagekit.io/kruyy0oih/1.png?updatedAt=1743523903741"
                alt=""
              />
            </div>
            <div className="info">
              <p className="name f_24">Amy</p>
              <div className="stars">
                <img src="./images/star.svg" alt="" />
                <img src="./images/star.svg" alt="" />
                <img src="./images/star.svg" alt="" />
                <img src="./images/star.svg" alt="" />
                <img src="./images/star.svg" alt="" />
              </div>
              <div className="des">
                "I joined after a friend shared her feedback report to me, I was
                impressed by how detailed it is. "
              </div>
            </div>
          </a>
        </div>

        <div className="matter">
          <a href="">
            <div className="pic">
              <img
                src="https://ik.imagekit.io/kruyy0oih/11.jpeg?updatedAt=1743523903863"
                alt=""
              />
            </div>
            <div className="info">
              <p className="name f_24">John</p>
              <div className="stars">
                <img src="./images/star.svg" alt="" />
                <img src="./images/star.svg" alt="" />
                <img src="./images/star.svg" alt="" />
                <img src="./images/star.svg" alt="" />
                <img src="./images/star.svg" alt="" />
              </div>
              <div className="des">
                "Our consulting club partnered with WeKruit, and it changed the
                game. I finally understood what high-quality feedback looks
                like. "
              </div>
            </div>
          </a>
          <a href="">
            <div className="pic">
              <img
                src="https://ik.imagekit.io/kruyy0oih/4.jpg?updatedAt=1743523902436"
                alt=""
              />
            </div>
            <div className="info">
              <p className="name f_24">Kevin</p>
              <div className="stars">
                <img src="./images/star.svg" alt="" />
                <img src="./images/star.svg" alt="" />
                <img src="./images/star.svg" alt="" />
                <img src="./images/star.svg" alt="" />
                <img src="./images/star.svg" alt="" />
              </div>
              <div className="des">
                "It’s rare to feel heard as a user. With WeKruit, every
                suggestion felt valued, and many became features. "
              </div>
            </div>
          </a>
          <a href="">
            <div className="pic">
              <img
                src="https://ik.imagekit.io/kruyy0oih/10.jpg?updatedAt=1743523901431"
                alt=""
              />
            </div>
            <div className="info">
              <p className="name f_24">Frank</p>
              <div className="stars">
                <img src="./images/star.svg" alt="" />
                <img src="./images/star.svg" alt="" />
                <img src="./images/star.svg" alt="" />
                <img src="./images/star.svg" alt="" />
                <img src="./images/star.svg" alt="" />
              </div>
              <div className="des">
                "Recruiting for consulting is tough. With WeKruit, I finally
                felt like I wasn’t doing it alone."
              </div>
            </div>
          </a>
        </div>

        <div className="matter">
          <a href="">
            <div className="pic">
              <img
                src="https://ik.imagekit.io/kruyy0oih/8.jpg?updatedAt=1743523902580"
                alt=""
              />
            </div>
            <div className="info">
              <p className="name f_24">Jessica</p>
              <div className="stars">
                <img src="./images/star.svg" alt="" />
                <img src="./images/star.svg" alt="" />
                <img src="./images/star.svg" alt="" />
                <img src="./images/star.svg" alt="" />
                <img src="./images/star.svg" alt="" />
              </div>
              <div className="des">
                "I stopped second-guessing myself once I saw clear progress in
                my reports and performance benchmarks. "
              </div>
            </div>
          </a>
          <a href="">
            <div className="pic">
              <img
                src="https://ik.imagekit.io/kruyy0oih/5.jpg?updatedAt=1743523902331"
                alt=""
              />
            </div>
            <div className="info">
              <p className="name f_24">Wendy</p>
              <div className="stars">
                <img src="./images/star.svg" alt="" />
                <img src="./images/star.svg" alt="" />
                <img src="./images/star.svg" alt="" />
                <img src="./images/star.svg" alt="" />
                <img src="./images/star2.svg" alt="" />
              </div>
              <div className="des">
                "WeKruit spread through our club like wildfire. It just works. "
              </div>
            </div>
          </a>
          <a href="">
            <div className="pic">
              <img
                src="https://ik.imagekit.io/kruyy0oih/2.jpg?updatedAt=1743523901313"
                alt=""
              />
            </div>
            <div className="info">
              <p className="name f_24">Becky</p>
              <div className="stars">
                <img src="./images/star.svg" alt="" />
                <img src="./images/star.svg" alt="" />
                <img src="./images/star.svg" alt="" />
                <img src="./images/star.svg" alt="" />
                <img src="./images/star.svg" alt="" />
              </div>
              <div className="des">
                "Our consulting club partnered with WeKruit, and it changed the
                game. I finally understood what high-quality feedback looks
                like. "
              </div>
            </div>
          </a>
        </div>
      </div>
      <a href="https://linktr.ee/wekruit" className="more wow fadeInUp">
        Join Our Community
      </a>
    </div>
  );
}

export default Community;
